import BusinessPageLayout from '../components/BusinessPageLayout';
import Content from './content';

/* Order Portal Maintenance Page */

const PageMaintenance = () => {
  return (
    <BusinessPageLayout pageName="maintenance">
      <Content />
    </BusinessPageLayout>
  );
};

export default PageMaintenance;
